export const IS_DELIVER_ON_SERVING_DATE_OPTIONS = [
  {
    label: 'Delivery Date',
    value: false,
  },
  {
    label: 'Serving Date',
    value: true,
  },
];



// WEBPACK FOOTER //
// ./src/pages/schoolsiteorder/helpers/Constants.js